import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import API from "../../apis"
import {
    Row,
    Col,
    Spinner
    , Label, Form, CardTitle,
} from "reactstrap"
import {withRouter} from "react-router"
import Select from "react-select";
import {Slide, toast, ToastContainer} from "react-toastify";
import FileDownload from "js-file-download"

const DataTablePlanEtudeEtat = props => {
    const [loading, setLoading] = useState(false)
    const [annee, setAnnee] = useState("");
    const [imp, setImp] = useState(0);
    const [excel, setExcel] = useState(0);
    var userAuthEnseignant = JSON.parse(
        localStorage.getItem("userAuthEnseignant")
    )
    var enseignant_id = userAuthEnseignant.user.enseignant_id
    var annee_id = userAuthEnseignant.user.annee_id
    useEffect(async () => {
        setLoading(true)
    }, [])
    const uploadPDF = async () => {
        window.open('https://scolarite.backcresus-institut.ovh/api/pdf/cahier_de_suivi_pour_discuter_la_fin_des_etudes/'
            + annee_id + '/' + enseignant_id
            , '_blank')
    }
    const uploadExcel = async () => {
        await API.get(`excel/cahier_de_suivi_pour_discuter_la_fin_des_etudes/${annee_id}/${enseignant_id}`, {responseType: "blob"}
        ).then(res => {
            FileDownload(res.data, "جذاذة تأطير إجازة.xlsx")
        })
    }
    const uploadPDFRepartitionNombre = async () => {
        window.open('https://scolarite.backcresus-institut.ovh/api/pdf/cahier_de_suivi_pour_discuter_la_fin_des_etudes_master/'
            + annee_id + '/' + enseignant_id
            , '_blank')
    }
    const uploadExcelRepartitionNombre = async () => {
        await API.get(`excel/cahier_de_suivi_pour_discuter_la_fin_des_etudes_master/${annee_id}/${enseignant_id}`, {responseType: "blob"}).then(res => {
            FileDownload(res.data, "جذاذة تأطير ماجستير.xlsx")
        })
    }
    return (
        <React.Fragment>
            <div>
                {loading ? (
                    <Row>
                        <Form>
                            <Row>
                                <Col lg="3" style={{textAlign: "center"}}>

                                    <div className="text-center mt-4">
                                        <a className="btn  mb-2 me-2" onClick={uploadPDF}
                                           style={{height: "80px", borderColor: "#7d7b7b", width: "100%"}}
                                           target="_blank"
                                           rel="noreferrer"
                                        ><i
                                            style={{
                                                color: "#761C19",
                                                cursor: "pointer",
                                                fontSize: "30px",
                                                margin: "0px 6px 0px 0px"
                                            }}
                                            className="fas fa-file-pdf"
                                        ></i>
                                            <p> {"جذاذة تأطير إجازة "}</p>
                                        </a>
                                    </div>
                                </Col>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    <div className="text-center mt-4">
                                        <a className="btn  mb-2 me-2" onClick={uploadPDFRepartitionNombre}
                                           style={{height: "80px", borderColor: "#7d7b7b", width: "100%"}}
                                           target="_blank"
                                           rel="noreferrer"
                                        ><i
                                            style={{
                                                color: "#761C19",
                                                cursor: "pointer",
                                                fontSize: "30px",
                                                margin: "0px 6px 0px 0px"
                                            }}
                                            className="fas fa-file-pdf"
                                        ></i>
                                            <p> {"جذاذة تأطير ماجستير"}</p>
                                        </a>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Row>
                ) : (
                    <div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            {" "}
                            <Spinner type="grow" className="ms-6" color="primary"/>
                        </div>
                        <h4
                            style={{textAlign: "center", marginTop: "2%"}}
                            className="ms-6"
                        >
                            {" "}
                            En cours ...{" "}
                        </h4>
                    </div>
                )}
            </div>
            <ToastContainer
                transition={Slide}
                enableMultiContainer
                containerId={"A"}
                position={toast.POSITION.TOP_RIGHT}
                autoClose={2500}
            />
        </React.Fragment>
    )
}

export default withRouter(DataTablePlanEtudeEtat)
DataTablePlanEtudeEtat.propTypes = {
    orders: PropTypes.array,
    history: PropTypes.object,
}
